import getRequestParams from '../utilities/get-request-params';

const addUTMParams = () => {
    
    const addParamsToIframeSrc = (iframe) =>
    {
        const requestParams = getRequestParams();
        
        // The footer demo form loads with a data-src attribute so that the pardot form is not automatically invoked
        let src = iframe.getAttribute('data-src') 
            ? iframe.getAttribute('data-src') 
            : iframe.getAttribute('src') 
        
        const params = [];

        if( requestParams.utm_source )   params.push('utm_source=' + requestParams.utm_source);
        if( requestParams.utm_medium )   params.push('utm_medium=' + requestParams.utm_medium);
        if( requestParams.utm_campaign ) params.push('utm_campaign=' + requestParams.utm_campaign);
        if( requestParams.utm_content ) params.push('utm_content=' + requestParams.utm_content);

        if( params.length )
        {
            src = src + '?' + params.join('&');
        }

        // The footer demo form loads with a data-src attribute so that the pardot form is not automatically invoked
        if( iframe.getAttribute('data-src') )
        {
            iframe.setAttribute('data-src', src);
        }
        else
        {
            iframe.setAttribute('src', src);
        }
    }

    const iframes = document.querySelectorAll('.js-add-utm');
    if( iframes )
    {
        for(let i=0; i<iframes.length; i++)
        {
            const iframe = iframes[i].querySelector('iframe');
            if( iframe )
            {
                addParamsToIframeSrc( iframe );
            }
        }
    }
}

export default addUTMParams;